import React, { ReactNode } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";

// Community Pages
import CommunityType from "pages/community/Community";
import People from "pages/community/People";
import PeopleImport from "pages/community/People/PeopleImport";
import Addresses from "pages/community/Addresses";
import Map from "pages/community/Map";
import DiscipleshipPathway from "pages/community/DiscipleshipPathway";

// Layouts
import Navbar_Internal from "components/PageLayouts/PageFrames/navbar_internal";
import Footer_Internal from "components/PageLayouts/PageFrames/footer_internal";
import Sidebar_Community from "components/PageLayouts/PageFrames/sidebar_community";

interface InternalLayoutProps {
  children: ReactNode;
}

const InternalLayout = ({ children }: InternalLayoutProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_Internal />
    <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>{children}</Box>
    <Footer_Internal />
  </Box>
);

const CommunityLayout = () => (
  <Box sx={{ display: "flex", flex: 1 }}>
    <Sidebar_Community />
    <Outlet />
  </Box>
);

export default function CommunityModule() {
  return (
    <Routes>
      <Route element={<InternalLayout><Outlet /></InternalLayout>}>
        <Route element={<CommunityLayout />}>
          <Route path="/" element={<CommunityType />} />
          <Route path="/:id/" element={<CommunityType />} />

          <Route path="/people/" element={<People />} />
          <Route path="/people/:id/" element={<People />} />

          <Route path="/people/import/" element={<PeopleImport />} />

          <Route path="/addresses/" element={<Addresses />} />
          <Route path="/addresses/:id/" element={<Addresses />} />

          <Route path="/map/" element={<Map />} />

          <Route path="/discipleship-pathway/" element={<DiscipleshipPathway />} />
          <Route path="/discipleship-pathway/:id/" element={<DiscipleshipPathway />} />
          
        </Route>
      </Route>
    </Routes>
  );
}
